import { Navigate, Route, Routes } from "react-router-dom";
import "./app.css";
import { Layout } from "./components/Layout";
import { MarketingPage } from "./pages/MarketingPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { SupportPage } from "./pages/SupportPage";
import { TermsPage } from "./pages/TermsPage";

export function App() {
	return (
		<Routes>
			<Route path="/" element={<Layout />}>
				<Route index element={<MarketingPage />} />
				<Route path="terms" element={<TermsPage />} />
				<Route path="privacy" element={<PrivacyPage />} />
				<Route path="support" element={<SupportPage />} />
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>
		</Routes>
	);
}

export default App;
